import React from "react";
import { useNavContext } from "../context-api/nav-context";

const PageHeaderSmall = ({ title }) => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <div className="conditions_heading" onMouseOver={closeNavbarMenu}>
      <h1 className="title title-color ">{title}</h1>
    </div>
  );
};

export default PageHeaderSmall;
